// extracted by mini-css-extract-plugin
module.exports = {"sitemap-screen":"Sitemap_sitemap-screen__iIJmF","sitemap-card":"Sitemap_sitemap-card__Wdvo6"};